import { render } from "./CertiAccInfoW.vue?vue&type=template&id=77dd91d6"
import script from "./CertiAccInfoW.vue?vue&type=script&lang=js"
export * from "./CertiAccInfoW.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__